import { render, staticRenderFns } from "./purchaseInsurance.vue?vue&type=template&id=72746cfc&"
import script from "./purchaseInsurance.vue?vue&type=script&lang=js&"
export * from "./purchaseInsurance.vue?vue&type=script&lang=js&"
import style0 from "./purchaseInsurance.vue?vue&type=style&index=0&id=72746cfc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports